import React from 'react';
import { TriStateCheckboxIndicator } from 'src/modules/shared/components/atoms/inputs/tri-state-checkbox';
import { Text } from 'src/modules/shared/components/atoms/text';
import type { I18nContextValue } from 'src/modules/shared/types/i18n/i18n.type';
import { getPropertyFeatureStateLabelKey } from '../../utils/property-editor-form.util';

interface PropertyFeatureStateLegendProps {
  /** Element id that each feature control references through `aria-describedby`. */
  id: string;
  /** Translation function for the state names and the cycle explanation. */
  t: I18nContextValue['t'];
}

const LEGEND_VALUES: readonly (boolean | null)[] = [true, false, null];

/**
 * One-line legend for the property feature controls: what yes, no and not set
 * look like, and that each click moves to the next state.
 */
export const PropertyFeatureStateLegend: React.FC<
  PropertyFeatureStateLegendProps
> = ({ id, t }) => (
  <div
    id={id}
    className="flex flex-wrap items-center gap-x-4 gap-y-1.5 rounded-lg border border-neutral-200 bg-neutral-50 px-3 py-2"
  >
    {LEGEND_VALUES.map((value) => (
      <span key={String(value)} className="inline-flex items-center gap-1.5">
        <TriStateCheckboxIndicator value={value} size="xs" />
        <Text
          as="span"
          size="tiny"
          weight="medium"
          className="text-neutral-700"
        >
          {t(getPropertyFeatureStateLabelKey(value))}
        </Text>
      </span>
    ))}
    <Text as="span" size="tiny" className="text-neutral-500">
      {t('catalog.properties.form.featureState.legend')}
    </Text>
  </div>
);
